import { FaBullhorn, FaCreditCard, FaMagnifyingGlass, FaArrowsRotate, FaNetworkWired, FaUserCheck } from "react-icons/fa6";


export const collectionSteps = [
    {
        id: 1,
        number: "01",
        icon: <FaBullhorn />,
        title: "Attract New Patients",
        description:
            "A strong website helps your practice stand out and convert more visitors into patients.",
    },
    {
        id: 2,
        number: "02",
        icon: <FaCreditCard />,
        title: "Convenient Payment Options",
        description:
            "Integrated payment options make it easier for patients to pay for services online.",
    },
    {
        id: 3,
        number: "03",
        icon: <FaMagnifyingGlass />,
        title: "SEO Optimization",
        description:
            "SEO strategies improve search visibility, attract more visitors, and grow your online presence.",
    },
];


export const featuresCardData = [
    {
        icon: <FaNetworkWired />,
        title: "Expand Referral Network",
        description:
            "We help you stay connected with referrers and new patient leads. This ensures no opportunity slips through the cracks.",
    },
    {
        icon: <FaUserCheck />,
        title: "Improved Patient Retention",
        description:
            "Regular follow-ups keep patients engaged. They help retain them for appointments and services.",
    },
    {
        icon: <FaArrowsRotate />,
        title: "Upgraded Processes",
        description:
            "Our services integrate with scheduling and payment systems to keep your workflow running smoothly.",
    },
]

export const proProgramsData = [
    {
        id: 1,
        title: "Targeted Patient Acquisition",
        description:
            "We run ads to attract patients seeking your healthcare services.",
    },
    {
        id: 2,
        title: "Optimized Campaigns",
        description:
            "We constantly check and improve your campaigns for the best ROI.",
    },
    {
        id: 3,
        title: "Smooth Payment Integration",
        description:
            "We ensure a smooth shift from your ads to booking and payment for new patients.",
    },
    {
        id: 4,
        title: "Performance Tracking",
        description:
            "We track key campaign metrics to measure results and identify opportunities for growth.",
    },
];